<div class="d-flex flex-column" style="border-radius: 30px">
  <div class="p-3 d-flex flex-column" style="min-height: 100vh">
    <div class="d-flex mb-4 px-4 header">
      <div class="icon-box me-3">
        <i class="bi bi-person-fill my-auto" style="font-size: 26px"></i>
      </div>
      <h1 class="my-auto">Carga masiva de colaboradores</h1>
    </div>
    <div class="p-5 mx-4 mb-5 mt-1 content">
      <img src="assets/svg/error-symbol.svg" height="40" class="mt-3 mb-4" />
      <h1 class="mb-3" style="font-size: 21px; font-weight: 700">
        Error al cargar la planilla
      </h1>
      <div style="font-size: 18px; font-weight: 600" class="mb-2">
        {{ MainTextError }}
      </div>
      <div style="font-size: 16px; font-weight: 400" class="mb-3">
        {{ explanationText }}
      </div>
      <div style="font-size: 16px; font-weight: 400" *ngIf="showDownloadUrl">
        Descarga el formato de planilla
        <b>
          <a
            href="https://aramark-prod-chile.s3.us-east-1.amazonaws.com/files/Consumers-new.xlsx"
            style="color: #1b5183"
            download
            >haciendo click aquí</a
          ></b
        >
      </div>
    </div>
  </div>
</div>
<div class="my-3 position-absolute close-btn mx-3">
  <a
    [routerLink]="[]"
    class="text-dark"
    (click)="close()"
    style="
      color: #adadad !important;
      font-weight: 500;
      font-size: 13px;
      text-decoration: none;
    "
  >
    Cerrar <i class="ms-2 bi bi-x-lg"></i>
  </a>
</div>
